var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m13 13 7.071-6.317a5.866 5.866 0 0 1 8.225 0 5.7 5.7 0 0 1 0 8.127L15.959 27 3.7 14.81a5.7 5.7 0 0 1 0-8.127 5.866 5.866 0 0 1 8.225 0S16.582 10.533 19 13"
  })));
};
export default SvgHeart;